import { RestChatService } from '@repo/network'
import { ComponentMessageMediaVO } from '@repo/types'
import { GenericAbortSignal } from 'axios'
import { useCallback } from 'react'
import { compressMedia } from '@web/modules/core'

export const useSendMediaToServer = () => {
  const uploadMedias = useCallback(
    async (files: FileList, connectionKey: string, signal?: GenericAbortSignal): Promise<ComponentMessageMediaVO[]> => {
      const medias: ComponentMessageMediaVO[] = []
      for (let i = 0; i < files.length; i++) {
        const formData = new FormData()
        const file = files[i]
        const mimeType = file.type
        let fileToUpload = file
        const fileSizeInMB = file.size / (1024 * 1024)

        if (mimeType.startsWith('image/') && fileSizeInMB > 5) {
          try {
            fileToUpload = await compressMedia(file, 5)
          } catch (err) {
            console.error('Erro ao comprimir imagem:', err)
          }
        } else if (mimeType.startsWith('video/') && fileSizeInMB > 16) {
          try {
            fileToUpload = await compressMedia(file, 16)
          } catch (err) {
            console.error('Erro ao comprimir vídeo:', err)
          }
        }

        formData.append('file', fileToUpload)
        const media = await RestChatService.uploadMedia(formData, connectionKey, signal)
        medias.push(media)
      }
      return medias
    },
    []
  )

  return {
    uploadMedias
  }
}
